const WEAK_PINS = new Set([
  '0000', '1111', '2222', '3333', '4444', '5555', '6666', '7777', '8888', '9999',
  '1234', '4321', '1212', '2121', '1122', '2211',
  '2580', '0852', '1004', '2000', '2001', '2020', '2021', '2024', '1990', '1995',
  '0123', '6969', '1313',
]);

export function isPinFormatValid(pin: string): boolean {
  return /^\d{4}$/.test(pin);
}

export function isPinWeak(pin: string): boolean {
  return WEAK_PINS.has(pin);
}
